(ns ycweb.app.website.myaccount.reviews.view
  (:require
    [ycweb.components.flow :as flow]
    [rum.core :as rum]
    [ycweb.components.transitions :as t]
    [ycweb.util.comms :as comms]
    [ycweb.util.core :as u]
    [ycweb.util.date :as ud]
    [ycweb.util.urlstate :as urlstate]
    [ycweb.components.toaster :as toaster]
    [ycweb.components.buttons :as buttons]
    [ycweb.components.headings :as headings]
    [ycweb.app.website.common :as web-common]
    [ycweb.app.website.myaccount.reviews.common :as reviews-common]
    [ycweb.app.website.myaccount.common :as awm.common]
    [ycweb.components.common :as cmn]))

(rum/defc reviews-view < rum/reactive [app-atom]
  (let [action-atom (cmn/action-cursor app-atom)
        {:review/keys [date-added status]
         :item-line/keys [product variation] :as review-item}
        (cmn/curact action-atom [:review])
        {:variation/keys [feature1 feature2]} variation
        {:product/keys [link]} product

        features
        (cond
          (and (u/presence feature1) (u/presence feature2)) (str feature1 ", " feature2)
          (and (u/presence feature1)) feature1
          (and (u/presence feature2)) feature2)]
    [:div.dashboard
     [:div
      {:class (u/bem :dashboard [:underline])}
      (headings/heading "Read your Review" {:type :h2 :size :medium})
      [:p {:class (u/bem :yc-paragraph [:flush])}
       "Below is your review of the "
       [:a.text-link {:href link} (str (:ent/display-name product) (when features (str ", " features)))] " submitted on " (ud/date-format (ud/coerce-date date-added) "dd MMM YYYY")]]

     (cond
       (= status "Pending")
       [:p {:class (u/bem :yc-paragraph [:flush])}
        [:span.text-status--warning "This review is still " [:b "pending"]] " and will be processed soon."]

       (= status "Accepted")
       [:p {:class (u/bem :yc-paragraph [:flush])}
        [:span.text-status--success "This review has been " [:b "accepted"]] " and has been published."]

       (= status "Rejected")
       [:p {:class (u/bem :yc-paragraph [:flush])}
        [:span.text-status--error "This review has been " [:b "rejected"]] " by our team, as it contravenes our reviews policy."])
     [:div.u-max-width-890
      (reviews-common/review-block review-item)]
     [:div.dashboard-footer.button-group
      (buttons/button-web "View product page"
        {:href link
         :style :secondary
         :size :default})]
     (toaster/loading-overlay app-atom :web.myaccount/reviewsview)]))

(defmethod flow/render-screen :web.myaccount/reviewview [app-atom _]
  (awm.common/screen-wrapper app-atom
    (reviews-view app-atom)))

(defmethod t/transition-open :web.myaccount/reviewview [app-atom _ params]
  (toaster/open-overlay app-atom :web.myaccount/reviewsview)
  (comms/ajax-get :web.myaccount/reviewview (select-keys params [:uuid])))

(defmethod comms/receive :web.myaccount/reviewview [app-atom e]
  (swap! (cmn/action-cursor app-atom) assoc
    :review (:review e))
  (toaster/close-overlay app-atom :web.myaccount/reviewsview))